import React from 'react';
import PropTypes from 'prop-types';

/* eslint-disable max-len */
const Golf = (props) => {
  const { height, width, fill, className } = props;
  return (
    <svg
      id="golf"
      width={width}
      height={height}
      stroke="none"
      className={className}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          d="M39.8813 21.661C40.0664 21.4984 40.1716 21.2633 40.1694 21.0169V8.72878C40.1678 8.41788 39.9961 8.13282 39.722 7.98606C39.4479 7.83929 39.1155 7.85439 38.8559 8.02539C32.644 11.8983 26.4321 2.71183 20.2118 5.55081C20.5115 5.97492 20.6742 6.48064 20.6779 6.99996V19.7711C27.0762 17.4406 33.483 27.2288 39.8813 21.661Z"
          fill={fill}
        />
        <path
          d="M50.9491 45.8559C48.8135 44.9322 42.822 43.3136 43.2627 40.4237C43.5762 38.3644 47.4999 39.0508 47.5677 37.0339C47.6101 35.6695 45.6694 35.4068 44.5169 35.339C36.7796 34.4831 28.305 34.2458 20.6779 35.8305V42.0085C23.8559 43.7034 22.3135 47.3729 18.1356 47.3729C13.9576 47.3729 12.4322 43.661 15.5932 42.0085V37.2034C11.7881 38.4746 5.62708 41.1017 5.42369 45.1271C5.19488 49.7966 11.8813 51.7203 15.9152 52.5254L16.1864 52.5847C22.488 53.946 28.9454 54.4449 35.3813 54.0678C40.4195 53.7783 45.4236 53.0581 50.3389 51.9152C52.2542 51.3644 55.5593 50.3559 53.9491 47.9661C53.1587 47.0039 52.1218 46.2746 50.9491 45.8559ZM39.322 49.9152C37.4498 49.9152 35.9322 48.3976 35.9322 46.5254C35.9322 44.6533 37.4498 43.1356 39.322 43.1356C41.1941 43.1356 42.7118 44.6533 42.7118 46.5254C42.7118 48.3976 41.1941 49.9152 39.322 49.9152Z"
          fill={fill}
        />
        <path
          d="M17.2881 6.99991V43.983C17.2881 44.451 17.6675 44.8304 18.1355 44.8304C18.6036 44.8304 18.983 44.451 18.983 43.983C18.983 4.24567 19.0932 6.80499 18.7796 6.44906C18.549 6.17939 18.1748 6.08194 17.8419 6.20487C17.5091 6.3278 17.2881 6.64508 17.2881 6.99991Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="50" height="50" fill="white" transform="translate(5 5)" />
        </clipPath>
      </defs>
    </svg>
  );
};
/* eslint-enable max-len */

Golf.defaultProps = {
  className: null,
};

Golf.propTypes = {
  height: PropTypes.number.isRequired,
  width: PropTypes.number.isRequired,
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};
export default Golf;
